import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import Reveal from "@/components/site/Reveal";

const faqs = [
  {
    q: "Como recebo o ebook depois da compra?",
    a: "Assim que o pagamento é confirmado, você recebe o acesso imediato por e-mail. O Plano 40+ é um arquivo digital (PDF) que pode ser lido no celular, tablet ou computador — e impresso, se preferir.",
  },
  {
    q: "É um livro físico?",
    a: "Não. O Plano 40+ é 100% digital, o que garante acesso imediato após a compra, sem frete e sem espera.",
  },
  {
    q: "Preciso seguir uma dieta restritiva?",
    a: "Não. Essa é justamente a proposta do método: emagrecer com organização e constância, sem cardápios impossíveis e sem cortar tudo o que você gosta. O foco é em hábitos sustentáveis para a sua realidade depois dos 40.",
  },
  {
    q: "Tenho mais de 50 (ou 60) anos. Funciona para mim?",
    a: "Sim. O método foi pensado para quem já passou dos 40 e sente que o metabolismo mudou. Quanto mais distante dos métodos antigos você estiver, mais o passo a passo estruturado faz diferença.",
  },
  {
    q: "E se eu não gostar do conteúdo?",
    a: "Você tem 7 dias de garantia incondicional. Se sentir que o Plano 40+ não é para você, basta pedir o reembolso dentro do prazo e devolvemos 100% do valor — sem perguntas.",
  },
];

const Faq = () => (
  <section id="faq" data-testid="faq-section" className="border-t border-border py-24 lg:py-32">
    <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:px-6 lg:grid-cols-12 lg:px-8">
      <Reveal className="lg:col-span-5">
        <p className="eyebrow mb-5 text-accent">Dúvidas frequentes</p>
        <h2 className="font-display text-3xl font-semibold leading-tight tracking-tight text-foreground sm:text-4xl lg:text-5xl">
          Tudo o que você precisa saber{" "}
          <span className="italic text-primary">antes de recomeçar.</span>
        </h2>
      </Reveal>

      <Reveal delay={0.15} className="lg:col-span-7">
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={faq.q}
              value={`item-${i}`}
              data-testid={`faq-item-${i + 1}`}
              className="border-border"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i + 1}`}
                className="py-6 text-left font-display text-xl font-semibold text-foreground hover:text-primary hover:no-underline"
              >
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="pb-6 leading-relaxed text-muted-foreground">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);

export default Faq;
